import {createSelector} from 'reselect';
import props from '../../../../props';

export default createSelector(
    props.wallet.methods.applepay_deposit,
    (applepay_deposit) => {
        return {
            props: applepay_deposit[applepay_deposit.stage]
        }
    }
)